<template>
	<div>
		<modalDeliveryPrice v-model="dialog" :propAdd='paramProp' :isCity="isCity" :val='val' />
		<modalconfirm ref="modalConfirmDelete" @action="deleteData" />
		<div class="d-flex justify-space-between">
			<div class="text-h5">Konfigurasi Biaya Pengiriman</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click="() => tambah()">
						<v-icon>mdi-plus-circle</v-icon>
						<div v-if="!isCity" class="pl-2 text-capitalize">Tambah Konfigurasi Biaya Pengiriman Provinsi</div>
						<div v-else class="pl-2 text-capitalize">Tambah Konfigurasi Biaya Pengiriman Kota / Kabupaten</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" v-if="isCity" @click="isCity = !isCity; onResetFilter()">
						<v-icon>mdi-arrow-left-bold</v-icon>
						<div class="pl-2 text-capitalize">Kembali ke Provinsi</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="provinceData(ListDeliveryPrice, isCity)" :search="search"
				hide-default-footer :options.sync="option" :server-items-length="deliveryPricePagination.total_data">
				<template v-slot:item.province="{ item }">
					<div class="pl-2 my-auto">{{ item.province }}</div>
				</template>
				<template v-slot:item.city_name="{ item }">
					<div class="pb-2">{{ item.city_name }}</div>
				</template>
				<template v-slot:item.delivery_setting_price="{ item }">
					<div class="pb-2">{{ item.delivery_setting_price | toNumber }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom v-if="item.delivery_setting_city_id == 0">
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="getCity(item.delivery_setting_province_id)" class="mr-1" fab dark x-small depressed color="indigo"
								v-bind="attrs" v-on="on">
								<v-icon dark>mdi-cog</v-icon>
							</v-btn>
						</template>
						<span>Konfigurasi Biaya Pengiriman Kota / Kabupaten</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="ubah(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click.stop="hapus(item)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div> </div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!deliveryPricePagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="deliveryPricePagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="deliveryPricePagination.total_page" @input="changePage" total-visible="7" circle
						class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" @input="changeLimit"
						label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modalDeliveryPrice from '@/views/MLwarehouse/purchaseOrderStockist/modalSettingDeliveryPrice.vue'
import { mapActions, mapState, mapMutations } from 'vuex'

const allProvince = {
	province: 'Semua Provinsi',
	province_id: ''
}

const allCity = {
	city_name: 'Semua Kab/Kota',
	city_id: '',
	type: 'Kota'
}

export default {
	inject: ['theme'],
	components: {
		modalDeliveryPrice
	},
	data() {
		return {
			page: 1,
			limit: "10",
			listLimit: ['5', '10', '20', '50', '100'],
			propDelete: '',
			paramProp: '',
			paramDelid: '',
			paramDelName: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			search: '',
			isCity: false,
			headers: [
				{ text: 'Provinsi', align: 'start', sortable: true, value: 'province' },
				{ text: 'Kota/Kabupaten', value: 'city_name', sortable: false },
				{ text: 'Biaya Pengiriman (Rp.)', value: 'delivery_setting_price', sortable: false },
				{ text: 'Aksi', value: 'action', sortable: false, },
			],
			filterData: [{
				type: 'selection-dynamic',
				label: 'Provinsi',
				itemValue: 'province_id',
				itemText: 'province',
				item: [allProvince],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'delivery_setting_province_id',
					show: true
				}
			}, {
				type: 'selection-dynamic',
				label: 'Kota',
				itemValue: 'city_id',
				itemText: 'city_name',
				item: [allCity],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'delivery_setting_city_id',
					show: false
				}
			}],
			params: [],
			paramStatus: {
				id: '',
				status: ''
			}
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState('so', ['ListDeliveryPrice', 'response', 'deliveryPricePagination', 'konfirmResponse', 'loading']),
	},
	methods: {
		...mapActions('so', ['getDeliveryPrice', 'getOptionProvince', 'getOptionCityResults', 'deleteDeliveryPrice']),
		...mapMutations(['setOverlay', 'setFilter', 'clearDataSO']),
		// ...mapMutations('supplierList', ['clearDataSupplier']),

		provinceData(data, isCity) {
			if (isCity) {
				return data.filter(item => item.delivery_setting_city_id != 0)
			}
			return data.filter(item => item.delivery_setting_city_id == 0)
		},
		getData() {
			this.getDeliveryPrice(this.queryString({ limit: this.limit, page: this.page, params: this.params, sort: this.sortBy, dir: this.sortDir }))
		},
		async getCity(provinceId) {
			this.isCity = true
			this.filterData[0].filter.value = provinceId

			this.filterData[1].item = [allCity, ...await this.getOptionCityResults(provinceId)]

			await this.getDeliveryPrice(this.queryString({ limit: this.limit, page: this.page, params: [...this.params, { field: 'delivery_setting_province_id', type: 'numeric', comparison: '=', value: provinceId }, { field: 'delivery_setting_city_id', type: 'numeric', comparison: '<>', value: 0 }], sort: this.sortBy, dir: this.sortDir }))
			this.page = 1

			await this.setFilter(this.filterData)
		},
		editStatus(stat) {
			this.paramStatus.id = stat.supplier_id
			if (stat.supplier_is_active == false) {
				this.paramStatus.status = 'inactive'
			} else {
				this.paramStatus.status = 'active'
			}
			this.statusSupplier(this.paramStatus).then(() => {
				this.getData()
				this.paramStatus.id = ''
				this.paramStatus.status = ''
			})
		},
		hapus(item) {
			this.propDelete = item.delivery_setting_id
			if (this.isCity) {
				this.paramDelName = `biaya pengiriman ${item.province} - ${item.city_name}`
			} else {
				this.paramDelName = `biaya pengiriman ${item.province}`
			}
			let msg = `Yakin ingin menghapus data ` + this.paramDelName + `?`
			this.$refs.modalConfirmDelete.setMessage(msg)
			this.$refs.modalConfirmDelete.showConfirm()
		},
		async deleteData() {
			await this.setOverlay(true)
			await this.$refs.modalConfirmDelete.hideConfirm()
			await this.deleteDeliveryPrice({ id: this.propDelete }).then(() => {
				if (this.response.code == 200) {
					this.setOverlay(false)
					if (!this.isCity) {
						this.getData()
					} else {
						this.getDeliveryPrice(this.queryString({ limit: this.limit, page: this.page, params: [...this.params, { field: 'delivery_setting_province_id', type: 'numeric', comparison: '=', value: this.filterData[0].filter.value }, { field: 'delivery_setting_city_id', type: 'numeric', comparison: '<>', value: 0 }], sort: this.sortBy, dir: this.sortDir }))
						this.page = 1
					}
				}
			}).catch(() => {
				this.setOverlay(false)
			})
			// await this.setOverlay(false)
		},
		tambah() {
			this.dialog = true;
			this.paramProp = 'tambah';
			if (this.isCity) {
				this.val = {
					delivery_setting_province_id: this.filterData[0].filter.value,
				}
			} else {
				this.val = {};
			}
		},
		ubah(item) {
			this.val = item;
			this.dialog = true;
			this.paramProp = 'edit';
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		onResetFilter() {
			this.filterData[0].filter.value = ''
			this.filterData[1].filter.value = ''

			this.params = []
			this.getData()
		},
		async selectProvince(val) {
			this.filterData = [...this.filterParams]

			let indexCity = this.filterData.findIndex(el => el.label == 'Kota')
			this.filterData[indexCity].filter.value = ''

			this.filterData[indexCity].item = [allCity, ...await this.getOptionCity(val)]

			await this.setFilter(this.filterData)
		},
	},
	async created() {
		let indexProvince = await this.filterData.findIndex(el => el.label == 'Provinsi')

		this.filterData[indexProvince].item = [allProvince, ...await this.getOptionProvince()]
		await this.setFilter(this.filterData)

		await this.getData()
		await this.setFilter(this.filterData)
		this.$store.dispatch('setPageTitle', `Konfigurasi Biaya Pengiriman`)
		// this.getGeolocation();
	},
	beforeDestroy() {
		this.clearDataSO()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		},
		isCity(val) {
			if (!val) {
				this.filterData[1].filter.show = false
				this.filterData[1].filter.value = ''
				this.filterData[0].filter.disabled = false
			} else {
				this.filterData[1].filter.show = true
				this.filterData[0].filter.disabled = true
			}
		},
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}

.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>